// services/hls.client.ts

import axios from "axios";
import axiosInstance from "@/lib/axios";

import type {
  TrailerPlaySuccessResponse,
  ApiErrorResponse,
  ThumbnailItem,
  ThumbnailsQueryParams,
  ThumbnailsResponse,
} from "@/types/hls";

export async function getClientThumbnails(
  params: ThumbnailsQueryParams,
): Promise<ThumbnailItem[]> {
  try {
    const { data } = await axiosInstance.get<ThumbnailsResponse>(
      `/hls/thumbnails/${params.content_uuid}`,
      {
        params: {
          entity_type: params.entity_type,
          entity_uuid: params.entity_uuid,
          ...(params.profile_uuid ? { profile_uuid: params.profile_uuid } : {}),
        },
      },
    );
    return data?.data?.thumbnails ?? [];
  } catch {
    return [];
  }
}

export async function getTrailerPlayback(
  trailerUuid: string,
): Promise<TrailerPlaySuccessResponse | ApiErrorResponse> {
  try {
    const { data } = await axiosInstance.get<TrailerPlaySuccessResponse>(
      `/trailers/${trailerUuid}/play`,
    );

    return data;
  } catch (err: unknown) {
    console.log("Error in getTrailerPlayback:", err);

    if (axios.isAxiosError(err)) {
      return (
        err.response?.data || {
          succeed: false,
          reason: "ERR_UNEXPECTED",
          error: {
            code: "ERR_UNEXPECTED",
            details: "",
            messages: ["دریافت اطلاعات فایل با خطا مواجه شد."],
            numeric_code: 5000,
          },
        }
      );
    }

    return {
      succeed: false,
      reason: "ERR_UNEXPECTED",
      error: {
        code: "ERR_UNEXPECTED",
        details: "",
        messages: ["دریافت اطلاعات فایل با خطا مواجه شد."],
        numeric_code: 5000,
      },
    };
  }
}